import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/z9psxsca_5ca02298-928c-4bb4-98fb-11237ebedacb.jpeg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Apartments', href: '#apartments' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'Amenities', href: '#amenities' },
    { name: 'Location', href: '#location' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Concord Apartments Logo" 
                className="w-14 h-14 rounded-xl object-cover shadow-lg"
              />
              <div>
                <span className="font-serif text-xl font-medium text-white">
                  Concord
                </span>
                <p className="text-[10px] text-slate-500 tracking-[0.15em] uppercase">Nakasero Hill</p>
              </div>
            </div>
            <p className="text-amber-400 text-sm font-medium italic mb-4">
              &ldquo;Tailored to Your Highest Standards&rdquo;
            </p>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Luxury apartments for sale in Kampala&apos;s most prestigious address.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/concord_apartments"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Unit Types */}
          <div>
            <h4 className="font-medium text-lg mb-6">Available Units</h4>
            <ul className="space-y-4">
              <li>
                <span className="text-slate-400 text-sm">3 Bedroom</span>
                <span className="block text-amber-400 text-sm font-medium">190 m² • $330,000</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">3+1 Bedroom</span>
                <span className="block text-amber-400 text-sm font-medium">250 m² • $350,000</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">Penthouse</span>
                <span className="block text-amber-400 text-sm font-medium">530 m² • $850,000</span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-medium text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
                <a href={`tel:${contactInfo.phone}`} className="text-slate-400 hover:text-white transition-colors text-sm">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${contactInfo.email}`} className="text-slate-400 hover:text-white transition-colors text-sm break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Concord Apartments. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Luxury Apartments for Sale in Kampala, Uganda
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
